module.exports = __webpack_public_path__ + "static/code-0a33e29ce4a9f68244fa5893ba5619a1.png";